    function initServicesAccordion() {
		const accordionRoot = document.querySelector('.accordion-list');
		const accordionItems = document.querySelectorAll('.accordion-list .accordion-item');

		accordionItems.forEach(item => {
			item.addEventListener('click', () => {
				item.classList.toggle('toggled');

				// Wait for the CSS transition to complete, then refresh ScrollTrigger
				const content = item.querySelector('.accordion-content__body');
				if (content) {
					const onTransitionEnd = () => {
						if (typeof ScrollTrigger !== 'undefined') {
							ScrollTrigger.refresh();
						}
						content.removeEventListener('transitionend', onTransitionEnd);
					};
					content.addEventListener('transitionend', onTransitionEnd);
				} else {
					// Fallback: slight delay then refresh
					setTimeout(() => typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh(), 250);
				}
			});
		});

		// Robust: observe layout changes and refresh scroll triggers
		if (accordionRoot && 'ResizeObserver' in window && typeof ScrollTrigger !== 'undefined') {
			const ro = new ResizeObserver(() => {
				ScrollTrigger.refresh();
			});
			ro.observe(accordionRoot);
		}
    }
